export const popularTipo = (results, tipo) => {
  if (results) {
    for (let r of results) {
      r.tipo = tipo;
    }
  }
}

